module.exports = __webpack_public_path__ + "img/ess_bg02.8c3aa218.svg";